class AnimatedTrack extends HTMLElement {
  constructor() {
    super();
  }

  resizeHandler = this.setDimensions.bind(this);
  scrollHandler = this.render.bind(this);

  connectedCallback() {
    this.svg = this.querySelector('svg');
    this.tracks = this.svg.querySelectorAll('path, line');
    this.createCircle();

    this.top = 0;
    this.bottom = 0;
    this.totalTrackLength = 0;
    this.setDimensions();

    window.addEventListener('resize', this.resizeHandler);
    document.addEventListener('scroll', this.scrollHandler);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeHandler);
    document.removeEventListener('scroll', this.scrollHandler);
  }

  createCircle() {
    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('r', 5);
    circle.setAttribute('cx', 0);
    circle.setAttribute('cy', 0);
    circle.setAttribute('fill', '#EF8D9A');
    circle.setAttribute('fill-opacity', 0);
    circle.setAttribute('class', 'circle');

    const svg = this.querySelector('svg');
    svg.appendChild(circle);

    this.circle = circle;
  }

  setDimensions() {
    requestAnimationFrame(() => {
      if (!this?.getBoundingClientRect) return;
      const rect = this.getBoundingClientRect();
      this.top = rect.top;
      this.bottom = rect.bottom;

      let totalTrackLength = 0;
      for (const track of this.tracks) {
        totalTrackLength += track.getTotalLength();
      }
      this.totalTrackLength = totalTrackLength;

      this.render();
    });
  }

  render() {
    requestAnimationFrame(() => {
      const scrollMid = window.scrollY + window.innerHeight / 2;
      const progress = (scrollMid - this.top) / (this.bottom - this.top);
      if (progress < 0 || progress > 1) {
        this.circle.setAttribute('fill-opacity', 0);
        return;
      }

      let distance = this.totalTrackLength * progress;
      for (const track of this.tracks) {
        if (distance > track.getTotalLength()) {
          distance -= track.getTotalLength();
          continue;
        }

        const point = track.getPointAtLength(distance);
        this.circle.setAttribute('cx', point.x);
        this.circle.setAttribute('cy', point.y);
        this.circle.setAttribute('fill-opacity', 1);
        break;
      }
    });
  }
}

customElements.define('animated-track', AnimatedTrack);
